import { memo } from 'react';

import { CheckIcon } from '@air/design-icons';

import { type ClipDiscussion } from '~/components/Annotations/shared/types';
import { BOUNDING_BOX_AVATAR_WIDTH, BoundingBoxAvatar } from '~/components/BoundingBox/components/BoundingBoxAvatar';
import { type BoundingBoxAvatarDirection, getHorizontalOpposite } from '~/components/BoundingBox/types';
import { ANNOTATION_AVATAR_BUTTON } from '~/constants/testIDs';

export type AnnotationAvatarButtonProps = {
  discussion: ClipDiscussion;
  onAvatarClick: (discussion: ClipDiscussion) => void;
  position: BoundingBoxAvatarDirection;
};

export const AnnotationAvatarButton = memo(({ discussion, position, onAvatarClick }: AnnotationAvatarButtonProps) => {
  return (
    <button
      data-testid={ANNOTATION_AVATAR_BUTTON}
      // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
      onClick={(event) => {
        event.stopPropagation();
        onAvatarClick(discussion);
      }}
      type="button"
    >
      <BoundingBoxAvatar
        account={discussion.comments.data[0]?.account}
        className={
          discussion.resolved
            ? 'ads:bg-ads-gray-5 light:bg-gray-5 dark:bg-gray-11'
            : 'ads:bg-ads-gray-3 light:bg-gray-3 dark:bg-gray-12'
        }
        direction={getHorizontalOpposite(position)}
      />
      {discussion.resolved && (
        <div
          className="absolute flex items-center justify-center bg-black/60"
          style={{
            borderRadius: BOUNDING_BOX_AVATAR_WIDTH,
            height: BOUNDING_BOX_AVATAR_WIDTH,
            width: BOUNDING_BOX_AVATAR_WIDTH,
          }}
        >
          <CheckIcon className="text-white" size="sm" />
        </div>
      )}
    </button>
  );
});

AnnotationAvatarButton.displayName = 'AnnotationAvatarButton';
